<template>
  <base-drawer
    :open="open"
    :close="close"
    @onClose="closeDrawer()"
    :title="`Adicionar domínio ${getTitle()}`"
    :goBack="step === 1 ? false : true"
    :back="step === 1 ? false : true"
    @onBack="jumpToStep(step, true)"
  >
    <base-card v-if="step === 1">
      <div class="read-instructions">
        <p class="title">Leia as instruções</p>
        <p class="description">
          Para ativar seu domínio são necessárias algumas configurações
          adicionais externas. Siga as instruções abaixo.
        </p>
        <div class="d-flex justify-center">
          <a
            href="https://ajuda.easydelivery.com.br/artigos-complementares/como-configurar-um-dominio-proprio"
            target="_blank"
            class="link"
          >
            <base-button text="Ver instruções" design="six" class="w-100 big" />
          </a>
        </div>
      </div>

      <base-checkbox v-model="read" :check="read" @click="read = !read">
        <p>Li e realizei as instruções</p>
      </base-checkbox>
    </base-card>

    <base-card v-if="step === 2">
      <base-label text="Insira o domínio do seu site" />
      <base-input
        class="mb_0"
        v-model="urlDomain"
        :valid="!errorDomain"
        prefix="https://"
      />
      <base-message
        v-show="!!errorDomain"
        :design="'red'"
        :messages="[errorDomain]"
        class="mb_15 mt_10"
      />
    </base-card>

    <template slot="footer">
      <base-button
        v-if="step === 1"
        class="w-100"
        text="Continuar"
        @click="jumpToStep(2)"
        :disabled="!read"
      />

      <base-button
        v-if="step === 2"
        class="w-100"
        text="Adicionar"
        :loading="loading"
        @click="jumpToStep(3)"
      />
    </template>
  </base-drawer>
</template>

<script>
import { mapState } from 'vuex';

/* eslint-disable import/no-unresolved */
import BaseTitle from '@/components/Title';
import BaseEmpty from '@/components/Empty';
import BaseBadge from '@/components/Badge';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';
import BaseLabel from '@/components/Label';
import BaseCard from '@/components/Card';
import BaseSteps from '@/components/Steps';
import BaseMessage from '@/components/MultiplesMessages';
import BaseCheckbox from '@/components/Checkbox';
import DomainAPI, { Domain } from '@/api/domain';

const components = {
  BaseTitle,
  BaseEmpty,
  BaseBadge,
  BaseButton,
  BaseInput,
  BaseAdd,
  BaseDrawer,
  BaseLabel,
  BaseCard,
  BaseSteps,
  BaseMessage,
  BaseCheckbox,
};

export default {
  components,
  props: {
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
  },
  data() {
    return {
      urlDomain: '',
      errorDomain: null,
      loading: false,
      urlConfiguration1: '{domain} CNAME {server}',
      copyUrl1: false,
      step: 1,
      copyLink: false,
      favorite: null,
      domainSaved: false,
      read: false,
    };
  },
  methods: {
    getTitle() {
      switch (this.step) {
        case 1:
          return '';
        case 2:
          return '- URL';
        default:
          return '';
      }
    },
    async jumpToStep(step, back) {
      if (step === 0) {
        return this.closeDrawer();
      }

      if (step === 3 && !back) {
        // Validar dominio
        if (Domain.test(this.urlDomain)) {
          this.errorDomain = 'Domínio inválido!';
          return false;
        }

        if (this.storeDomains.indexOf(this.urlDomain) > -1) {
          this.errorDomain = 'Domínio já cadastrado!';
          return false;
        }

        this.urlConfiguration1 = `${this.urlDomain} CNAME ${process.env.VUE_APP_FRONT_DNS_ADDRESS}`;
        this.errorDomain = null;

        try {
          this.loading = true;

          const { exists } = await DomainAPI.exists(this.urlDomain);
          if(exists) {
            this.errorDomain = "Este domínio já está sendo utilizado por outra loja na Easy Delivery."
            this.loading = false;
            return false;  
          }

          await DomainAPI.add(this.urlDomain);
          this.$emit('save');
          this.closeDrawer();
        } catch (err) {
          alert(err.message);
          this.loading = false;
          return false;
        }
      }

      if (back) {
        this.step = step - 1;
        this.read = false;
        this.loading = false;
      } else {
        this.step = step;
      }
    },
    closeDrawer() {
      this.urlDomain = '';
      this.$emit('cancel');
      this.step = 1;
    },
  },
  computed: {
    ...mapState({
      storeDomains: (state) => state.store.configurations.domains || [],
    }),
  },
  watch: {
    urlDomain(newValue) {
      this.errorDomain = null;
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid > div {
  margin-bottom: 0;
}
.grid > .add-box {
  height: 180px;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 1px solid #99999926;
}
.status {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
}
.input-copy {
  position: relative;
}
.input-copy .copy {
  position: absolute;
  bottom: 6px;
  right: 15px;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
}
.input-copy .copy i {
  color: var(--icon-inactive);
  font-size: 17px;
}
.copy-code {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
}
.link-instructions {
  color: #aaaaab80;
  font-size: 12px;
  line-height: 15px;
  left: 15px;
  text-align: center;
}
.link-instructions a {
  color: #aaaaab80;
  font-weight: 900;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
  text-decoration: none;
}
.link-instructions a:hover {
  color: var(--label-secondary);
  border-color: var(--label-secondary);
}
.url-config {
  color: #aaaaabbf;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: bold;
}
.timer {
  background: #45484d80;
  border-radius: 5px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
}
.timer p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-left: 10px;
}
.timer i {
  font-size: 14px;
  color: var(--icon-inactive);
}
.status p {
  font-size: 14px;
  color: #cccccc;
  margin-top: 15px;
}
.buttons {
  display: flex;
}
.buttons button:not(:last-child) {
  margin-right: 15px;
}
.url-1,
.url-2 {
  display: flex;
  align-items: center;
  padding: 5px;
  min-height: 45px;
  border-radius: 5px;
}
.url-1 {
  background: transparent;
  border: 1px solid #515159;
}
.url-2 {
  background: #45484d99;
}
.url-2 .prefix {
  background: #494c52;
  padding: 10px;
  color: var(--label-primary);
  margin-right: 10px;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  height: 36px;
}
.url-1 p,
.url-2 p {
  color: var(--label-primary);
  font-size: 12px;
}
.url-1 i,
.url-2 i {
  color: var(--icon-inactive);
  font-size: 17px;
  cursor: pointer;
}

.hairline {
  margin: 30px auto;
  border-top: 1px solid #ffffff17;
  width: 100%;
}

.read-instructions {
  padding: 30px 20px 20px;
  background: #3f4145;
  border: 2px dashed #ffffff17;
  margin-bottom: 15px;
}

.read-instructions p.title {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
  font-weight: bold;
  text-align: center;
}

.read-instructions p.description {
  font-size: 14px;
  color: var(--label-primary);
  line-height: 22px;
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.read-instructions p.description:last-child {
  margin-bottom: 0;
}

.read-instructions p.description span {
  font-weight: bold;
  display: block;
}

.read-instructions p.description span {
  color: var(--default);
  font-weight: 900;
}

.link {
  width: 100%;
  text-align: center;
  color: var(--label-primary);
  font-size: 14px;
  text-decoration: none;
}

.link:hover {
  border-color: var(--default);
}

@media screen and (max-width: 991px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .status p {
    font-size: 10px;
  }
  .grid > .add-box {
    height: auto;
  }
}
</style>
